import {
  DateTimeFormatter,
  LocalDateTime,
  LocalTime,
  ZonedDateTime
} from 'js-joda';
import { isEmpty } from 'lodash';

export interface DateTime {
  date: string;
  time: string;
}

const dateTimeFormat = DateTimeFormatter.ofPattern(
  "yyyy-MM-dd'T'HH:mm:ss[.SSS][xxx][xx][X]"
);

export class TimeTransform {
  static join(dateStr: string, timeStr: string): string {
    const time = LocalTime.parse(timeStr);
    const joinedDate = LocalDateTime.parse(dateStr)
      .withHour(time.hour())
      .withMinute(time.minute())
      .withSecond(time.second())
      .withNano(time.nano());
    return joinedDate.format(
      DateTimeFormatter.ofPattern("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
    );
  }

  static split(dateTime: string): DateTime {
    const dt = LocalDateTime.parse(dateTime.toString());
    const date = dt.toLocalDate().toString();
    const time = dt.toLocalTime().toString();
    return { date, time };
  }

  // js-joda does not support the full ISO8601 spec
  // https://github.com/js-joda/js-joda/issues/254
  static parseFromFullFormat(dateStr: string): ZonedDateTime {
    return ZonedDateTime.parse(dateStr, dateTimeFormat);
  }

  static parse(dateTime: string): DateTime {
    if (isEmpty(dateTime)) {
      return { date: null, time: null };
    }

    return TimeTransform.split(
      TimeTransform.parseFromFullFormat(dateTime)
        .toLocalDateTime()
        .toString()
    );
  }
}
